module.exports = __webpack_public_path__ + "img/VERSAPRINT 2 ULTRA3.b2d0f3cc.png";